hmi.utils.action_execute = function () {
    "use strict";

    var sizeIcon = 24;
    var startSvg = '<svg xmlns = "http://www.w3.org/2000/svg" xmlns: xlink = "http://www.w3.org/1999/xlink"' + 'width = "' + sizeIcon + 'pt" height = "' + sizeIcon + 'pt" viewBox = "0 0 480 480" version = "1.1">' +
        '<g id="surface1">' +
        '<path style=" stroke:none;fill-rule:nonzero;fill:#2A9305;fill-opacity:1;" d="M 236.84375 47.367188 C 132.175781 47.367188 47.367188 132.175781 47.367188 236.84375 C 47.367188 341.507813 132.175781 426.316406 236.84375 426.316406 C 341.507813 426.316406 426.316406 341.507813 426.316406 236.84375 C 426.316406 132.175781 341.507813 47.367188 236.84375 47.367188 Z M 320.601563 243.195313 L 200.453125 312.519531 C 194.40625 316.035156 189.472656 313.199219 189.472656 306.167969 L 189.472656 167.453125 C 189.472656 160.484375 194.40625 157.648438 200.453125 161.101563 L 320.601563 230.488281 C 326.644531 234.003906 326.644531 239.679688 320.601563 243.195313 Z "/>' +
        '</g>' +
        '</svg';
    var stopSvg = '<svg xmlns = "http://www.w3.org/2000/svg" xmlns: xlink = "http://www.w3.org/1999/xlink"' + 'width = "' + sizeIcon + 'pt" height = "' + sizeIcon + 'pt" viewBox = "0 0 480 480" version = "1.1">' +
        '<g id="surface1">' +
        '<path style=" stroke:none;fill-rule:nonzero;fill:#A31B1B;fill-opacity:1;" d="M 236.84375 47.367188 C 132.175781 47.367188 47.367188 132.175781 47.367188 236.84375 C 47.367188 341.507813 132.175781 426.316406 236.84375 426.316406 C 341.507813 426.316406 426.316406 341.507813 426.316406 236.84375 C 426.316406 132.175781 341.507813 47.367188 236.84375 47.367188 Z M 315.789063 300 C 315.789063 308.695313 308.695313 315.789063 300 315.789063 L 173.683594 315.789063 C 164.988281 315.789063 157.894531 308.695313 157.894531 300 L 157.894531 173.683594 C 157.894531 164.988281 164.988281 157.894531 173.683594 157.894531 L 300 157.894531 C 308.695313 157.894531 315.789063 164.988281 315.789063 173.683594 Z "/>' +
        '</g>' +
        '</svg';
    var waitingSvg = '<svg xmlns = "http://www.w3.org/2000/svg" xmlns: xlink = "http://www.w3.org/1999/xlink"' + 'width = "' + sizeIcon + 'pt" height = "' + sizeIcon + 'pt" viewBox = "0 0 480 480" version = "1.1">' +
        '<g id="surface1">' +
        '<path style=" stroke:none;fill-rule:nonzero;fill:#057A93;fill-opacity:1;" d="M 221.050781 31.578125 C 212.355469 31.578125 205.261719 38.671875 205.261719 47.367188 L 205.261719 66.179688 C 124.589844 81.105469 63.15625 151.910156 63.15625 236.84375 C 63.15625 332.566406 141.117188 410.527344 236.84375 410.527344 C 332.566406 410.527344 410.527344 332.566406 410.527344 236.84375 C 410.527344 151.910156 349.09375 81.105469 268.421875 66.179688 L 268.421875 47.367188 C 268.421875 38.671875 261.328125 31.578125 252.632813 31.578125 Z M 362.972656 63.035156 C 356.558594 63.035156 350.824219 66.921875 348.355469 72.839844 C 345.949219 78.824219 347.367188 85.609375 351.996094 90.109375 L 367.785156 105.902344 C 371.730469 110.03125 377.652344 111.699219 383.140625 110.21875 C 388.691406 108.800781 393.011719 104.480469 394.429688 98.929688 C 395.910156 93.441406 394.242188 87.519531 390.109375 83.574219 L 374.320313 67.785156 C 371.359375 64.699219 367.289063 63.035156 362.972656 63.035156 Z M 236.84375 94.738281 C 315.542969 94.738281 378.949219 158.140625 378.949219 236.84375 C 378.949219 280.632813 359.210938 319.675781 328.1875 345.703125 L 236.84375 236.84375 Z "/>' +
        '</g>' +
        '</svg';

    var dispatch = d3.dispatch('action_run');

    var menu;
    var generateMenu = function (d) {
        if (d.config && d.config.actions && d.config.actions.values) {
            menu = d.config.actions.values.map(function (item) {
                return {
                    title: item.title,
                    action: function (elm, d, i) {
                        item.element = d.id;
                        dispatch.action_run(item);
                    }
                }
            });
        }
    }
    var htmlAction = function (d) {
        if (d.config && d.config.actions) {
            var svg;
            generateMenu(d);
            switch (d.config.actions.status) {
                case hmi.constant.actions_status.start:
                    svg = startSvg;
                    break;
                case hmi.constant.actions_status.waiting:
                    svg = waitingSvg;
                    break;
                case hmi.constant.actions_status.stop:
                    svg = stopSvg;
                    break;
                default:
                    svg = startSvg;
                    break;
            }
            return svg;
        } else {
            return '';
        }
    }

    function action_execute(gEnter, gComponet) {
        menu = undefined;
        gComponet.append('g')
            .classed('action_execute', true)
            .attr('transform', function (d) {
                return 'translate(' + (parseInt(d.width) + 15) + ',' + 0 + ')';
            });
        gEnter.select('g.action_execute')
            .html(htmlAction)
            .on('click', menu && menu.length !== 0 ? d3.contextMenu(menu) : undefined);

    }
    action_execute.dispatch = dispatch;
    action_execute._options = Object.create({}, {
    });
    hmi.utils.initOptions(action_execute);
    return action_execute;
};